import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";

import type { IFileStore } from "@/stores/fileStore/types";
import { APP_ID } from "@/constants/appId";

const name = `${APP_ID}/FILE_STORE`;

export const useFileStore = create<IFileStore>()(
  subscribeWithSelector(
    devtools(
      (set) => ({
        groupFilesMetadata: new Map(),
        groupFilesIsLoading: new Map(),
        filesModifySignal: 0,
        progressModifySignal: 0,
        isLoadingModifySignal: 0,
        updateFilesSignal() {
          set({ filesModifySignal: Math.random() });
        },
        updateProgressSignal() {
          set({ progressModifySignal: Math.random() });
        },
        updateIsLoadingSignal() {
          set({ isLoadingModifySignal: Math.random() });
        },
      }),
      {
        enabled: !import.meta.env.PROD,
        name,
      },
    ),
  ),
);
const filesStoreFn = {
  files: useFileStore.getState().groupFilesMetadata,
  updateFilesSignal: useFileStore.getState().updateFilesSignal,
  updateProgressSignal: useFileStore.getState().updateProgressSignal,
  updateIsLoadingSignal: useFileStore.getState().updateIsLoadingSignal,
  groupFilesIsLoading: useFileStore.getState().groupFilesIsLoading,
};

export { filesStoreFn };
